import './src/app.css';
import React from 'react';
import Header from './src/components/layout/Header';
import Footer from './src/components/layout/Footer';
export const wrapPageElement = ({ element, props }) => {
	let url = typeof window !== 'undefined' && window.location.href;

	return (
		<>
			<Header onlySeo={url.includes('/lp/')} />
			<main {...props}>{element}</main>
			{!url.includes('/lp/') && <Footer />}
		</>
	);
};
